import http from 'axios'
import history from './history'
import {message} from 'antd';

// response处理
function handleResponse(response) {
  let result;
  if (response.status === 401||response?.data?.code===1003) {
    // result = '会话过期，请重新登录';
    result = '';
    localStorage.setItem('token', '');
    localStorage.setItem('nickname', '');
    localStorage.setItem('userInfo','');

    if (history.location.pathname !== '/login') {

      history.push('/login', {from: history.location})
    } else {
      return Promise.reject()
    }
  } else if (response.status === 200) {
    if (response.data.error) {
      result = response.data.error
    } else if (response.data.hasOwnProperty('data')) {
      return Promise.resolve(response.data.data)
    } else if (response.headers['content-type'] === 'application/octet-stream') {
      return Promise.resolve(response)
    } else if (response.headers['content-type'] === 'application/vnd.ms-excel') {
      return Promise.resolve(response)
    } else if (response.data.code === 999) {
      return Promise.resolve(response)
    } else {
      result = '无效的数据格式'
    }
  } else {
    result = `请求失败: ${response.status} ${response.statusText}`
  }
  result && message.error(result);
  return Promise.reject(result)
}

// 请求拦截器
http.interceptors.request.use(request => {
  if (request.url.startsWith('/api/') || request.url.startsWith('/frontApi/') || request.url.startsWith('/javaApi/')) {
    request.headers['X-TOKEN'] = localStorage.getItem('token')
  }
  request.timeout = 30000;
  return request;
});

// 返回拦截器
http.interceptors.response.use(response => {
  return handleResponse(response)
}, error => {
  if (error.response) {
    return handleResponse(error.response)
  }
  const result = '请求异常: ' + error.message;
  message.error(result);
  return Promise.reject(result)
});

export default http;
